module.exports = __webpack_public_path__ + "img/2.8ef247d6.png";